function addRegistrationValidators() {
    $(function (){
         // Add validators

        // let validator = $('form.needs-validation').jbvalidator({
        //     errorMessage: true,
        //     successClass: true,
        //     language: "/i18n/validator/de.json"
        // });

        // //custom validate methode
        // validator.validator.custom = function(el, event){
        //     if($(el).is('[name=password]') && $(el).val().length < 5){
        //         return 'Your password is too weak.';
        //     }
        // }

        // validator.validator.example = function(el, event){
        //     if($(el).is('[name=username]') && $(el).val().length < 3){
        //         return 'Your username is too short.';
        //     }
        // }

        // //check form without submit
        // validator.checkAll(); //return error count

        // //reload instance after dynamic element is added
        // validator.reload();
    })
    
}

// //-- BASIC jQuery
// $(document).ready(function() {

// });